import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    '& .comments': {
      '&-group': {
        '&-responses': {
          padding: theme.spacing(0, 0, 3, 5),
        },
      },
    },
  },
}));

export default styles;
